import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Empty, Form, FormProps, Input, Select } from 'antd';
import { IFilter } from '../list';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { SearchOutlined } from '@ant-design/icons';
import { useSelect } from '@refinedev/antd';

export interface FaqCoordinatorFilterProps {
  searchFormProps: FormProps<IFilter>;
}

export const FaqCoordinatorFilter = ({
  searchFormProps
}: FaqCoordinatorFilterProps) => {
  const { selectProps: courseSelectProps } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server',
      pageSize: 100
    }
  });
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="title">
        <Input placeholder="Título do tópico" suffix={<SearchOutlined />} />
      </Form.Item>

      <Form.Item name="course">
        <Select
          {...courseSelectProps}
          placeholder="Selecione um curso"
          defaultValue={null}
          notFoundContent={
            <Empty description="Nenhum curso encontrado. Tente refazer sua busca com outros termos" />
          }
        />
      </Form.Item>

      <Form.Item name="userName">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="userEmail">
        <Input placeholder="Email do aluno" />
      </Form.Item>

      <Form.Item name="startsAt">
        <DatePicker
          className="w-full"
          placeholder="Data de postagem (a partir de)"
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="endsAt">
        <DatePicker
          className="w-full"
          placeholder="Data de postagem (término em)"
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="status">
        <Select placeholder="Selecione um status" defaultValue={null}>
          <Select.Option>Todos</Select.Option>
          <Select.Option key="pending">Não respondido</Select.Option>
          <Select.Option key="answered">Em andamento</Select.Option>
          <Select.Option key="closed">Concluído</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
